// All homepage copy. Persian (fa) is the default language.
export const content = {
  fa: {
    dir: "rtl",
    langLabel: "FA",
    meta: { title: "نورین — عمیق‌تر ببینید. بهتر تصمیم بگیرید.", description: "نورین؛ مشاورهٔ کسب‌وکار و رشد استراتژیک با پشتوانهٔ هوش مصنوعی. مشاورهٔ نخست رایگان است." },
    nav: { home: "خانه", services: "خدمات", how: "مسیر همکاری", about: "دربارهٔ نورین", consult: "مشاورهٔ رایگان", signin: "ورود", menu: "منو", close: "بستن" },
    preloader: "تجربهٔ نورین در حال آماده‌سازی است",
    tagline: "عمیق‌تر ببینید. بهتر تصمیم بگیرید.",
    hero: {
      lines: ["شفافیت", "برای هر بلندپروازی."],
      sub: "استراتژی هوشمندتر؛ کسب‌وکاری استوارتر.",
      desc: "فرصت‌های تازه را ببینید، با اطمینان تصمیم بگیرید و با راهنمایی استراتژیکِ هوشمند و متناسب با کسب‌وکارتان، گام بعدی را محکم بردارید.",
      cta1: "مشاورهٔ رایگان را آغاز کنید",
      cta2: "با نورین آشنا شوید",
      free: "مشاورهٔ نخست رایگان است",
      scroll: "ادامه",
      label: "هستهٔ نورین",
    },
    marquee: ["عمیق‌تر ببینید. بهتر تصمیم بگیرید.", "استراتژی", "شناخت بازار", "رشد", "جایگاه برند", "شفافیت"],
    clarity: {
      eyebrow: "از پیچیدگی تا شفافیت",
      lines: ["چالش‌های پیچیده،", "مسیری روشن."],
      intro: "داده‌ها و نشانه‌های پراکنده، کنار هم معنا پیدا می‌کنند. همان‌طور که پیش می‌روید، رشتهٔ لامپ نورین آرام‌آرام روشن می‌شود و مسیر پیش رو را آشکار می‌کند.",
      items: [
        { n: "۰۱", title: "بازارتان را بهتر بشناسید", text: "پویایی بازار، نیاز واقعی مشتریان و فرصت‌های رقابتی پیش رو را دقیق‌تر ببینید." },
        { n: "۰۲", title: "فرصت‌های رشد را بیابید", text: "مسیرهای استراتژیک توسعه و گسترش کسب‌وکارتان را با دیدی روشن بسنجید." },
        { n: "۰۳", title: "سنجیده‌تر تصمیم بگیرید", text: "اطلاعات کسب‌وکار را به اولویت‌هایی روشن و گام‌هایی عملی تبدیل کنید." },
      ],
      states: ["پراکندگی", "انسجام"],
    },
    journey: {
      eyebrow: "مسیر همکاری با نورین",
      lines: ["چهار گام،", "یک مسیر روشن."],
      steps: [
        { n: "۰۱", title: "از کسب‌وکارتان بگویید", text: "کسب‌وکار، اهداف و چالش‌هایی را که با آن روبه‌رو هستید با ما در میان بگذارید." },
        { n: "۰۲", title: "فرصت‌ها را کشف کنید", text: "نورین نیازهای کسب‌وکارتان را تحلیل می‌کند و در شناسایی مسیرهای استراتژیک همراهتان است." },
        { n: "۰۳", title: "پیشنهاد اختصاصی دریافت کنید", text: "پیشنهادی متناسب با کسب‌وکار شما، با سه بسته و مزایای متمایز. قیمت مصوب هر بستهٔ یک‌باره هنگام بررسی کسب‌وکار نشان داده می‌شود و پشتیبانی ماهانه جداگانه برآورد می‌شود." },
        { n: "۰۴", title: "با اطمینان پیش بروید", text: "بستهٔ مناسب را برگزینید؛ پس از تأیید پرداخت، خدمات شما فعال می‌شود." },
      ],
    },
        capabilities: {
      eyebrow: "حوزه‌های تخصصی",
      lines: ["شش حوزه،", "یک نگاه یکپارچه."],
      hint: "یک حوزه را انتخاب کنید و جزئیات خدماتش را ببینید.",
      details: "مشاهده جزئیات خدمات",
      detailsClose: "بستن جزئیات",
      servicesLabel: "خدمات مشاوره‌ای",
      outputsLabel: "خروجی‌های ممکن",
      scopeNote: "دامنه و هزینه هر کار بعد از بررسی کسب‌وکار و در پیشنهاد تأییدشده مشخص می‌شود. خرید یک بسته به‌معنی شامل‌بودن همه این خدمات نیست.",
      cta: "شروع بررسی کسب‌وکار من",
      items: [
        {
          title: "استراتژی کسب‌وکار",
          text: "از شناخت وضعیت فعلی تا طراحی مسیر آینده؛ کمک می‌کنیم تصمیم‌های مهم کسب‌وکارتون هدفمندتر، روشن‌تر و قابل‌اجراتر باشن.",
          caption: "مسیرهایی که به مقصدی روشن می‌رسند",
          services: ["تحلیل مدل کسب‌وکار", "تشخیص وضعیت فعلی", "اولویت‌ها و برنامه استراتژیک", "حمایت در تصمیم‌های مهم", "تحلیل موقعیت رقابتی", "ارزیابی ریسک کسب‌وکار", "نقشه راه در دامنه توافق‌شده"],
          outputs: "گزارش تشخیص، اولویت‌های استراتژیک و نقشه راه اقدام؛ در محدوده بسته یا پیشنهاد تأییدشده.",
        },
        {
          title: "شناخت بازار و مشتری",
          text: "بازار، مشتری‌ها و رقباتون رو دقیق‌تر بشناسید تا فرصت‌ها رو بهتر ببینید و تصمیم‌هاتون فقط بر اساس حدس نباشه.",
          caption: "شبکه‌ای به‌هم‌پیوسته از نشانه‌ها",
          services: ["شناخت بازار و صنعت", "تحلیل رقبا", "مشتری هدف و بخش‌بندی", "نیاز، رفتار و مسیر مشتری", "تفسیر بازخورد مشتری", "ارزیابی تناسب محصول با بازار", "برآورد اندازه بازار، فقط وقتی داده قابل‌اتکا باشد"],
          outputs: "ارزیابی بازار، مقایسه رقبا، بینش مشتری و پیشنهاد فرصت‌ها. این کار تحلیل مشاوره‌ای است، نه تحقیق میدانی تضمین‌شده.",
        },
        {
          title: "رشد و گسترش",
          text: "کمک می‌کنیم مسیر جذب مشتری، فروش و رشد رو دقیق‌تر بررسی کنید و منابع‌تون رو روی فرصت‌های ارزشمندتر متمرکز کنید.",
          caption: "سازه‌هایی که رو به بالا قد می‌کشند",
          services: ["استراتژی بازاریابی و فروش", "بررسی قیف فروش و نرخ تبدیل", "جذب و نگهداشت مشتری", "استراتژی قیمت‌گذاری", "عملکرد کانال‌ها", "منطق فروش مکمل", "شاخص‌های عملکرد رشد"],
          outputs: "تشخیص فروش و بازاریابی، پیشنهاد قیف، آزمایش‌های رشد و شاخص‌های عملکرد. اجرای کمپین یا تبلیغات در این بخش وعده داده نمی‌شود.",
        },
        {
          title: "جایگاه برند",
          text: "مشخص کنید برندتون چه ارزشی ارائه می‌ده، چه تفاوتی با رقبا داره و چطور باید در ذهن مشتری‌ها شناخته بشه.",
          caption: "نشانی متقارن در کانون توجه",
          services: ["استراتژی و جایگاه برند", "تمایز و ارزش پیشنهادی", "پیام برند و مخاطب", "برداشت مشتری از برند", "یکدستی ارتباط برند", "استراتژی تجربه مشتری"],
          outputs: "پیشنهاد جایگاه، ارزش پیشنهادی، چارچوب پیام و مسیر استراتژی برند. طراحی گرافیک، ثبت علامت و تولید محتوا به‌خودی‌خود شامل نمی‌شود.",
        },
        {
          title: "توسعهٔ کسب‌وکار",
          text: "فرصت‌های توسعه رو شناسایی کنید و هم‌زمان فرایندهای داخلی رو برای رشد پایدارتر آماده کنید.",
          caption: "پل‌هایی میان دو ساحل",
          services: ["استراتژی توسعه کسب‌وکار", "کارایی عملیات و فرایندها", "فرصت درآمد و کانال توزیع", "آمادگی برای مقیاس", "اولویت‌بندی اجرا", "ارزیابی اینکه ابزار دیجیتال یا خودکارسازی کجا می‌تواند کمک کند"],
          outputs: "پیشنهاد بهبود عملیات، ارزیابی فرصت توسعه و اولویت‌های اجرا. ساخت نرم‌افزار یا انجام خودکارسازی وعده داده نمی‌شود.",
        },
        {
          title: "بینش مالی و عملکرد",
          text: "اعداد کسب‌وکارتون رو به بینش قابل‌استفاده تبدیل کنید؛ از هزینه و سود واقعی تا تصمیم مالی روشن‌تر.",
          caption: "موج‌هایی که به تعادل می‌رسند",
          services: ["عملکرد و سودآوری", "ساختار هزینه و اقتصاد قیمت", "بودجه و جریان نقد بر اساس اعداد شما", "نقطه سر به سر و اقتصاد واحد", "شاخص‌ها و سناریوهای مالی", "امکان‌سنجی در سطح تصمیم‌سازی"],
          outputs: "تشخیص مالی، تفکیک سودآوری، سناریوهای بودجه و تحلیل پشتیبان تصمیم. حسابرسی رسمی، نمایندگی مالیاتی، مشاوره سرمایه‌گذاری تحت نظارت یا ارزش‌گذاری الزام‌آور ارائه نمی‌شود.",
        },
      ],
    },
packages: {
      eyebrow: "مشاورهٔ اختصاصی",
      lines: ["کسب‌وکار شما یگانه است؛", "استراتژی‌اش هم باید باشد."],
      desc: "تجربه‌ای از مشاوره را کشف کنید که برای کسب‌وکار شما طراحی می‌شود؛ با پیشنهادی اختصاصی که بر پایهٔ اهداف و چالش‌هایتان شکل می‌گیرد.",
      priceNote: "قیمت مصوب، داخل بررسی کسب‌وکار",
      note: "هر بستهٔ یک‌باره قیمت مصوب مشخصی دارد که هنگام شروع بررسی کسب‌وکار و در مسیر خرید نمایش داده می‌شود. پشتیبانی ماهانه جداست و یکی از این بسته‌های ثابت نیست.",
      cta: "بررسی کسب‌وکار را شروع کنید",
      tiers: [
        { name: "پایه", latin: "Essential", availability: "بستهٔ یک‌باره با قیمت مصوب", scope: "دامنهٔ متمرکز", text: "برای کسب‌وکارهایی که به شفافیت استراتژیک پایه، توصیه‌های متمرکز و راهنمایی در اولویت‌های فوری نیاز دارند." },
        { name: "استاندارد", latin: "Standard", availability: "بستهٔ یک‌باره با قیمت مصوب", scope: "دامنهٔ ساختارمند", text: "برای کسب‌وکارهایی که تحلیلی عمیق‌تر، توسعهٔ استراتژیک ساختارمند و راهنمایی جامع‌تری برای رشد می‌خواهند." },
        { name: "پریمیوم", latin: "Premium", availability: "بستهٔ یک‌باره با قیمت مصوب", scope: "دامنهٔ جامع", text: "برای کسب‌وکارهایی با چالش‌های استراتژیک گسترده‌تر که به دامنهٔ مشاورهٔ پیشرفته و همراهی جامع‌تری نیاز دارند." },
      ],
    },
    human: {
      eyebrow: "هوشمندی با محوریت انسان",
      lines: ["فناوری با بینش،", "استراتژی با هدف."],
      body: "نورین تحلیل هوشمند را با نگاهی سنجیده و استراتژیک همراه می‌کند تا پیچیدگی‌های کسب‌وکار به درکی روشن و قابل‌اجرا تبدیل شود. فناوری الگوها را آشکار می‌کند؛ بینش به آن‌ها معنا می‌دهد.",
      layers: [
        { k: "داده", t: "اطلاعاتی که از بستر کسب‌وکار شما می‌آید." },
        { k: "الگو", t: "تحلیلی که ساختارها و پیوندها را آشکار می‌کند." },
        { k: "بینش", t: "درکی که به مسیری روشن و هدفمند می‌رسد." },
      ],
    },
    final: {
      lines: ["فصل تازهٔ کسب‌وکارتان", "با شفافیت آغاز می‌شود."],
      desc: "هر تحول ارزشمند، با پرسشی بهتر آغاز می‌شود.",
      cta1: "مشاورهٔ رایگان را آغاز کنید",
      cta2: "خدمات نورین را ببینید",
      free: "مشاورهٔ نخست رایگان است",
    },
    footer: {
      desc: "نورین، مشاورهٔ کسب‌وکار و رشد استراتژیک با پشتوانهٔ هوش مصنوعی است؛ همراهی برای کسب‌وکارهایی که می‌خواهند عمیق‌تر ببینند و بهتر تصمیم بگیرند.",
      explore: "دسترسی سریع",
      company: "نورین",
      social: "ما را دنبال کنید",
      services: "خدمات",
      about: "دربارهٔ نورین",
      how: "مسیر همکاری",
      contact: "تماس با ما",
      privacy: "حریم خصوصی",
      terms: "شرایط استفاده",
      email: "[ایمیل — جایگزین شود]",
      copyright: "© ۲۰۲۶ نورین. همهٔ حقوق محفوظ است.",
      proto: "نسخهٔ نمایشی صفحهٔ اصلی — پیوندها پس از یکپارچه‌سازی فعال می‌شوند",
      top: "بازگشت به بالا",
    },
    toast: { title: "این مسیر هنوز تنظیم نشده است", body: "پیوند پس از تعیین مسیر از سوی تیم فنی فعال می‌شود. متغیر:" },
    signature: { lines: ["عمیق‌تر ببین.", "هوشمندانه‌تر تصمیم بگیر."], label: "امضای بنیان‌گذار" },
  },
  en: {
    dir: "ltr",
    langLabel: "EN",
    meta: { title: "NOORIN — See Deeper. Decide Better.", description: "NOORIN — business consulting and strategic growth, supported by artificial intelligence. Your first consultation is free." },
    nav: { home: "Home", services: "Services", how: "How We Work", about: "About NOORIN", consult: "Free Consultation", signin: "Sign In", menu: "Menu", close: "Close" },
    preloader: "Preparing NOORIN",
    tagline: "See Deeper. Decide Better.",
    hero: {
      lines: ["Clarity for", "Every Ambition."],
      sub: "Smarter strategy, for a stronger business.",
      desc: "See new opportunities, decide with confidence, and take your next step on solid ground — with intelligent strategic guidance shaped around your business.",
      cta1: "Start Your Free Consultation",
      cta2: "Discover NOORIN",
      free: "Your first consultation is free",
      scroll: "Continue",
      label: "The NOORIN Core",
    },
    marquee: ["See Deeper. Decide Better.", "Strategy", "Market Insight", "Growth", "Brand Positioning", "Clarity"],
    clarity: {
      eyebrow: "From Complexity to Clarity",
      lines: ["Complex challenges,", "a clear direction."],
      intro: "Scattered data and signals begin to make sense together. As you move forward, the filament of the NOORIN bulb gradually comes to light, revealing the way ahead.",
      items: [
        { n: "01", title: "Know Your Market Better", text: "See market dynamics, real customer needs and the competitive openings ahead with greater precision." },
        { n: "02", title: "Find Your Growth Opportunities", text: "Weigh the strategic paths for developing and expanding your business with a clear view." },
        { n: "03", title: "Decide With Greater Judgement", text: "Turn business information into clear priorities and practical next steps." },
      ],
      states: ["Scattered", "Coherent"],
    },
    journey: {
      eyebrow: "Working With NOORIN",
      lines: ["Four steps,", "one clear path."],
      steps: [
        { n: "01", title: "Tell Us About Your Business", text: "Share your business, your goals and the challenges you are facing." },
        { n: "02", title: "Discover the Opportunities", text: "NOORIN analyses your business needs and works with you to identify strategic directions." },
        { n: "03", title: "Receive Your Tailored Proposal", text: "A proposal shaped around your business, with three packages and distinct benefits. The published one-time price is shown in your business review; monthly support is quoted separately." },
        { n: "04", title: "Move Forward With Confidence", text: "Choose the package that suits you; once your payment is confirmed, your services are activated." },
      ],
    },
        capabilities: {
      eyebrow: "Areas of Expertise",
      lines: ["Six disciplines,", "one integrated view."],
      hint: "Select a discipline, then open its services.",
      details: "View service details",
      detailsClose: "Hide service details",
      servicesLabel: "Consulting capabilities",
      outputsLabel: "Possible outputs",
      scopeNote: "The exact scope and fee are set after a business review, in an approved proposal. Buying a package does not include every service listed here.",
      cta: "Start my business review",
      items: [
        {
          title: "Business Strategy",
          text: "From understanding where the business stands today to shaping a clearer path forward, so important decisions become more deliberate and practical.",
          caption: "Paths that arrive at a clear destination",
          services: ["Business model analysis", "Current-state diagnosis", "Strategic priorities and planning", "Support for important decisions", "Competitive position analysis", "Business risk assessment", "A roadmap within the agreed scope"],
          outputs: "A diagnostic report, strategic priorities and an action roadmap, within the purchased package or an approved proposal.",
        },
        {
          title: "Market & Customer Insight",
          text: "See the market, customers and competitors more clearly, so opportunities are based on evidence rather than guesswork.",
          caption: "A connected network of signals",
          services: ["Market and industry understanding", "Competitor analysis", "Target customers and segmentation", "Customer needs, behaviour and journey", "Interpretation of customer feedback", "Product-market fit assessment", "Market sizing only where reliable information exists"],
          outputs: "A market assessment, competitor comparison, customer insights and opportunity recommendations. This is advisory analysis, not a guaranteed field study.",
        },
        {
          title: "Growth & Expansion",
          text: "Examine how customers are attracted, how sales happen and where growth effort is actually worth spending.",
          caption: "Structures rising upward",
          services: ["Marketing and sales strategy", "Sales funnel and conversion review", "Customer acquisition and retention", "Pricing strategy", "Channel performance", "Cross-sell and upsell logic", "Growth performance indicators"],
          outputs: "A sales and marketing diagnosis, funnel recommendations, growth experiments and performance indicators. Running campaigns or advertising is not included.",
        },
        {
          title: "Brand Positioning",
          text: "Clarify the value you offer, how you differ from competitors and how customers should recognise the brand.",
          caption: "A symmetrical mark at the centre of attention",
          services: ["Brand strategy and positioning", "Differentiation and value proposition", "Brand message and audience fit", "Customer perception of the brand", "Consistency of brand communication", "Customer experience strategy"],
          outputs: "Positioning recommendations, a value proposition, a messaging framework and a brand strategy path. Graphic production, trademark registration and content production are not automatically included.",
        },
        {
          title: "Business Development",
          text: "Identify development opportunities and prepare internal operations for more sustainable growth.",
          caption: "Bridges between two shores",
          services: ["Business development strategy", "Operational and process efficiency", "Revenue opportunities and distribution channels", "Readiness to scale", "Implementation priorities", "An assessment of where digital tools or automation could help"],
          outputs: "Operational improvement recommendations, a development opportunity assessment and implementation priorities. Building software or carrying out automation is not promised.",
        },
        {
          title: "Financial & Performance Insight",
          text: "Turn the business numbers you provide into usable insight, from real costs and profit to clearer financial decisions.",
          caption: "Waves finding their balance",
          services: ["Performance and profitability", "Cost structure and pricing economics", "Budget and cash flow from your figures", "Break-even and unit economics", "Financial indicators and scenarios", "Decision-level feasibility review"],
          outputs: "A financial diagnosis, a profitability breakdown, budget scenarios and decision-support analysis. This is not a certified audit, tax representation, regulated investment advice or a legally binding valuation.",
        },
      ],
    },
packages: {
      eyebrow: "Tailored Consulting",
      lines: ["Your business is unique;", "its strategy should be too."],
      desc: "A consulting experience designed around your business, with a tailored proposal built on your goals and challenges.",
      priceNote: "Published price, inside your business review",
      note: "Each one-time package has its own published price, shown when you start a business review and again in the purchase journey. Monthly support is quoted separately and is not one of these fixed packages.",
      cta: "Start a business review",
      tiers: [
        { name: "Essential", latin: "Essential", availability: "Fixed one-time package", scope: "Focused scope", text: "For businesses that need foundational strategic clarity, focused recommendations and guidance on immediate priorities." },
        { name: "Standard", latin: "Standard", availability: "Fixed one-time package", scope: "Structured scope", text: "For businesses that want deeper analysis, structured strategic development and broader guidance for growth." },
        { name: "Premium", latin: "Premium", availability: "Fixed one-time package", scope: "Comprehensive scope", text: "For businesses facing wider strategic challenges that call for advanced consulting and more comprehensive support." },
      ],
    },
    human: {
      eyebrow: "Human-Centred Intelligence",
      lines: ["Technology with perspective,", "strategy with purpose."],
      body: "NOORIN pairs intelligent analysis with a considered, strategic view, so the complexity of your business becomes clear understanding you can act on. Technology reveals the patterns; perspective gives them meaning.",
      layers: [
        { k: "Data", t: "Information drawn from the context of your business." },
        { k: "Pattern", t: "Analysis that reveals structures and connections." },
        { k: "Insight", t: "Understanding that leads to a clear, purposeful direction." },
      ],
    },
    final: {
      lines: ["Your next chapter", "begins with clarity."],
      desc: "Every meaningful transformation begins with a better question.",
      cta1: "Start Your Free Consultation",
      cta2: "Explore NOORIN's Services",
      free: "Your first consultation is free",
    },
    footer: {
      desc: "NOORIN offers business consulting and strategic growth, supported by artificial intelligence — a partner for businesses that want to see deeper and decide better.",
      explore: "Quick Links",
      company: "NOORIN",
      social: "Follow Us",
      services: "Services",
      about: "About NOORIN",
      how: "How We Work",
      contact: "Contact Us",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      email: "[email — placeholder]",
      copyright: "© 2026 NOORIN. All rights reserved.",
      proto: "Homepage preview — links become active after integration",
      top: "Back to top",
    },
    toast: { title: "This route is not configured yet", body: "The link will be activated once the technical team sets its route. Variable:" },
    signature: { lines: ["عمیق‌تر ببین.", "هوشمندانه‌تر تصمیم بگیر."], label: "Founder's signature" },
  },
};
